module.exports = __webpack_public_path__ + "img/libertyConference2021.e2f0878e.png";